// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"d3130f4c","891":"b5007a8e"}[chunkId] + ".chunk.css";
};